import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("qc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  const clean = (s) => String(s).replace(/^Value error,\s*/i, "");
  if (detail == null) return "Ocurrió un error. Inténtalo de nuevo.";
  if (typeof detail === "string") return clean(detail);
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? clean(e.msg) : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return clean(detail.msg);
  return String(detail);
}

export const fmt = (n, dec = 2) => {
  const v = Number(n || 0);
  return v.toLocaleString("es-MX", { minimumFractionDigits: dec, maximumFractionDigits: dec });
};

export default api;
